import React from "react";

const GoogleBusinessIcon = () => {
  return (
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#999"
      d="M4.456 1.922c-.861 0-1.622.578-1.85 1.409L.96 9.297v.065a3.127 3.127 0 0 0 3.12 3.12 3.12 3.12 0 0 0 2.639-1.466 3.11 3.11 0 0 0 2.641 1.466c1.113 0 2.09-.587 2.64-1.466a3.12 3.12 0 0 0 2.64 1.466 3.12 3.12 0 0 0 2.64-1.467 3.12 3.12 0 0 0 2.64 1.467 3.127 3.127 0 0 0 3.12-3.12v-.065l-1.646-5.966a1.92 1.92 0 0 0-1.85-1.41zm0 .96h2.673l-.794 5.76H2.137L3.53 3.587a.96.96 0 0 1 .925-.705m8.024 0h3.422l.794 5.76H12.48zM7.2 8.642h4.32v.72q.002.12.012.24H7.2v-.96m10.465 0h4.198l.21.758c-.002.07-.017.135-.024.202h-4.265c-.008-.08-.024-.158-.024-.24v-.033zm-15.714.96h4.265a2.144 2.144 0 0 1-2.136 1.92 2.14 2.14 0 0 1-2.13-1.92m10.577 0h4.224c-.123 1.079-.998 1.92-2.112 1.92s-1.989-.841-2.112-1.92M6.72 12.47a4.06 4.06 0 0 1-4.8.348v7.824c0 .794.646 1.44 1.44 1.44h17.28c.794 0 1.44-.646 1.44-1.44v-7.824a4.06 4.06 0 0 1-4.8-.349 4.06 4.06 0 0 1-2.64.973A4.06 4.06 0 0 1 12 12.47a4.06 4.06 0 0 1-2.64.972 4.06 4.06 0 0 1-2.64-.972m10.32 1.452c.982 0 1.859.457 2.43 1.169l-.686.687a2.15 2.15 0 0 0-1.744-.896c-1.19 0-2.16.969-2.16 2.16 0 1.19.97 2.16 2.16 2.16.937 0 1.73-.604 2.028-1.44H17.28v-.96h2.868q.01.12.012.24c0 1.72-1.4 3.12-3.12 3.12s-3.12-1.4-3.12-3.12 1.4-3.12 3.12-3.12"
    ></path>
  </svg>
  );
};

export default GoogleBusinessIcon;
